<template>
  <div class="tile is-parent">
      <div class="tile is-child has-text-left">
          <h1 class="title is-4 is-size-6-mobile has-text-white-ter mu-font is-uppercase">{{title}}</h1>
      </div>
      <div class="tile is-child is-hidden-mobile" v-if="breadcrumb.length>1">
          <BreadCrumb :data="breadcrumb" />
      </div>
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumbs/default'
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        breadcrumb: {
            type:Array,
            default: ()=>([])
        }
    },
    components: {
        BreadCrumb
    }
}
</script>

<style>

</style>